module.exports = __webpack_public_path__ + "8e060f6adce192df98cc9ba9c44917ce.svg";